/**
 * BBQ Rescher storefront interactions.
 *
 * This implementation intentionally uses browser-native APIs so it does not
 * depend on jQuery being loaded before this file.
 */
(function () {
  'use strict';

  function closestElement(event, selector) {
    return event.target instanceof Element ? event.target.closest(selector) : null;
  }

  function checkboxIsChecked(id) {
    var checkbox = document.getElementById(id);
    return checkbox instanceof HTMLInputElement && checkbox.checked;
  }

  function blockAction(event, message) {
    event.preventDefault();
    event.stopPropagation();
    window.alert(message);
  }

  function initializeStorefrontInteractions() {
    document.body.addEventListener('click', function (event) {
      var checkoutTrigger = closestElement(
        event,
        '[name="checkout"], [name="goto_pp"], [name="goto_gc"]'
      );

      if (
        checkoutTrigger &&
        (!checkboxIsChecked('agree_agb') || !checkboxIsChecked('agree_widerruf'))
      ) {
        blockAction(
          event,
          'Bitte akzeptieren Sie unsere Bedingungen, bevor Sie Ihren Kauf fortsetzen.'
        );
        return;
      }

      var contactTrigger = closestElement(event, '[name="contact-submit"]');

      if (contactTrigger && !checkboxIsChecked('agree_contact')) {
        blockAction(
          event,
          'Bitte akzeptieren Sie unsere Datenschutzhinweise, bevor Sie Ihre Nachricht absenden.'
        );
      }
    });

    if (window.location.pathname !== '/') {
      return;
    }

    var section = document.querySelector('section[data-custom-class="home-video"]');
    if (!section) {
      return;
    }

    var videos = section.querySelectorAll('.home-video');
    var youtubeVideo = section.querySelector('.home-video.youtube');
    var iframe = section.querySelector('.responsive-video iframe');

    videos.forEach(function (video) {
      video.addEventListener('click', function () {
        videos.forEach(function (item) {
          item.style.display = 'none';
        });

        if (youtubeVideo) {
          youtubeVideo.style.display = 'block';
        }

        if (iframe) {
          var videoUrl = new URL(iframe.src, window.location.href);
          videoUrl.searchParams.set('autoplay', '1');
          iframe.src = videoUrl.toString();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeStorefrontInteractions);
  } else {
    initializeStorefrontInteractions();
  }
})();
